import { CartContext } from '@/app/cart/context/cart';
import { storage } from '@/utils/storage';
import { User } from '@shop/models/src/identity';
import { useContext } from 'react';

export function isLoggedIn() {
  if (!storage.local.token.get()) {
    return '/';
  }
  return true;
}

export function isCartEmpty({ redirectTo } = { redirectTo: '/' }) {
  const { cart } = useContext(CartContext);
  if (!cart?.items.length) {
    return redirectTo;
  }
  return true;
}

export function isAddressSelected() {
  if (!storage.session.address.get<string>()) {
    return '/cart/address';
  }
  return true;
}

export function isAddressListEmpty() {
  if (!storage.local.user.get<User>().addresses.length) {
    return '/cart/address/form';
  }
  return true;
}
